class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector('.internal-video__play');
    this.noPlayBtn = this.dataset.noPlayBtn === 'true';
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector('.internal-video__sound-btn');
    this.video = this.querySelector('video');
    this.invalidFormatSrc = this.video.querySelector("source[type='application/x-mpegURL']");
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    this.timeline = this.querySelector('.internal-video__timeline');
    this.dragging = false;
    if (this.playButton) {
      this.playButton.addEventListener('click', this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener('click', this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener('ended', this.endedVideo.bind(this));
      this.video.addEventListener('waiting', this.showSpinner.bind(this));
      this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this));
      this.video.addEventListener('play', this.hideSpinner.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener('timeupdate', this.updateTimeline.bind(this));
      this.timeline.addEventListener('click', this.seekVideo.bind(this));
      this.timeline.addEventListener('mousedown', this.startDrag.bind(this));
      this.timeline.addEventListener('touchstart', this.startDrag.bind(this));
      document.addEventListener('mouseup', this.stopDrag.bind(this));
      document.addEventListener('touchend', this.stopDrag.bind(this));
      document.addEventListener('mousemove', this.drag.bind(this));
      document.addEventListener('touchmove', this.drag.bind(this));
    }
    if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.05,
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add('internal-video--playing');
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = 'hidden';
      }
      const playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.classList.add('internal-video--playing');
            if (this.playButton && this.noPlayBtn) {
              this.playButton.style.visibility = 'hidden';
            }
          })
          .catch(() => {
            this.classList.remove('internal-video--playing');
            if (this.playButton && this.noPlayBtn) {
              this.playButton.style.visibility = 'visible';
            }
          });
      }
    } else {
      this.video.pause();
      this.classList.remove('internal-video--playing');
    }
  }
  endedVideo() {
    this.classList.remove('internal-video--playing');
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove('internal-video--muted');
    } else {
      this.video.muted = true;
      this.classList.add('internal-video--muted');
    }
  }
  updateTimeline() {
    const progress = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty('--completed', `${progress}%`);
  }
  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }
  showSpinner() {
    this.classList.add('internal-video--loading');
  }
  startDrag(event) {
    event.preventDefault();
    this.dragging = true;
    this.drag(event);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(event) {
    if (!this.dragging) return;
    if (event.touches) {
      event = event.touches[0];
    }
    this.seekVideo(event);
  }
  seekVideo(event) {
    const timelineRect = this.timeline.getBoundingClientRect();
    const offsetX = event.clientX - timelineRect.left;
    const percent = offsetX / timelineRect.width;
    this.video.currentTime = percent * this.video.duration;
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.video.querySelectorAll('source[data-src]').forEach((source) => {
          source.setAttribute('src', source.getAttribute('data-src'));
          source.removeAttribute('data-src');
        });
        this.video.load();
        const playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise
            .catch((error) => {
              if (error.name === 'NotAllowedError') {
                this.classList.remove('internal-video--playing');
                if (this.playButton && this.noPlayBtn) {
                  this.playButton.style.visibility = 'visible';
                }
              }
            })
            .then(() => {
              this.video.play();
            });
          this.observer.disconnect();
        }
      }
    });
  }
}
customElements.define('internal-video', InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    (super(),
      (this.sliderOverlay = this.querySelector('.comparison-slider__overlay')),
      (this.sliderLine = this.querySelector('.comparison-slider__line')),
      (this.sliderInput = this.querySelector('.comparison-slider__input')),
      this.sliderInput.addEventListener('input', this.handleChange.bind(this)));
  }
  handleChange(event) {
    const percent = event.currentTarget.value;
    ((this.sliderOverlay.style.width = percent + '%'),
      (this.sliderLine.style.left = percent + '%'));
  }
}
customElements.define('comparison-slider', ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    (super(),
      (this.testMode = this.dataset.testMode === 'true'),
      (this.secondsDelay = this.dataset.delaySeconds),
      (this.daysFrequency = this.dataset.delayDays),
      (this.modal = this.querySelector('.sign-up-popup-modal')),
      (this.timer = this.querySelector('.popup-modal__timer')),
      (this.timerDuration = this.dataset.timerDuration),
      (this.closeBtns = this.querySelectorAll('.promp-popup__close-btn')),
      (this.overlay = document.querySelector('.sign-up-popup-overlay')),
      (this.storageKey = 'promo-bar-data-' + window.location.host));
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();
      else {
        const storedData = JSON.parse(localStorage.getItem(this.storageKey)),
          nextDisplayDate = new Date(storedData.next_display_date);
        currentDate.getTime() > nextDisplayDate.getTime() && this.openPopupModal();
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach((btn) => {
      btn.addEventListener('click', this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        (this.modal.classList.add('popup-modal--active'),
          this.overlay.classList.add('popup-overlay--active'));
        const nextDate = addDays(currentDate, parseInt(this.daysFrequency)),
          promoData = {
            next_display_date: nextDate,
            dismissed: false,
          };
        localStorage.setItem(this.storageKey, JSON.stringify(promoData));
        if (this.timer) this.displayPromoTimer();
      },
      parseInt(this.secondsDelay) * 1000 + 3000,
    );
  }
  displayPromoTimer() {
    ((this.minutesSpan = this.querySelector('.popup-modal__timer__minutes')),
      (this.secondsSpan = this.querySelector('.popup-modal__timer__seconds')),
      (this.totalSeconds = parseFloat(this.timerDuration) * 60),
      this.updateTimer());
    const timerInterval = setInterval(() => {
      ((this.totalSeconds -= 1),
        this.updateTimer(),
        this.totalSeconds <= 0 && (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45));
    }, 1000);
  }
  updateTimer() {
    let minutes = Math.floor(this.totalSeconds / 60);
    if (minutes.toString().length === 1) minutes = '0' + minutes;
    let seconds = this.totalSeconds % 60;
    if (seconds.toString().length === 1) seconds = '0' + seconds;
    ((this.minutesSpan.innerText = minutes), (this.secondsSpan.innerText = seconds));
  }
  closeModal() {
    (this.modal.classList.remove('popup-modal--active'),
      this.overlay.classList.remove('popup-overlay--active'));
  }
}
customElements.define('promo-popup', PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    (super(),
      (this.sectionOneContainer = this.querySelector('.section-group__section-one-container')),
      (this.sectionTwoContainer = this.querySelector('.section-group__section-two-container')),
      this.transferSections(),
      document.addEventListener('shopify:section:load', this.transferSections.bind(this)));
  }
  transferSections() {
    ((this.sectionOne = document.querySelector(
      this.dataset.sectionOneId + ' .content-for-grouping',
    )),
      (this.sectionTwo = document.querySelector(
        this.dataset.sectionTwoId + ' .content-for-grouping',
      )));
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length)
      this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length)
      this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define('section-group', SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    (super(),
      (this.button = this.querySelector('.clickable-discount__btn')),
      this.button.addEventListener('click', this.handleClick.bind(this)),
      this.dataset.applied === 'true' ? this.handleClick() : this.reapplyDiscountIfApplicable());
  }
  handleClick() {
    ((this.dataset.loading = 'true'),
      (this.button.disabled = true),
      (this.dataset.error = 'false'),
      fetch('/discount/' + this.dataset.code)
        .then((response) => {
          if (!response.ok) throw new Error('Error');
          ((this.dataset.applied = 'true'),
            sessionStorage.setItem('discount-' + this.dataset.code + '-applied', 'true'));
        })
        .catch((error) => {
          ((this.dataset.error = 'true'), (this.button.disabled = false));
        })
        .finally(() => {
          this.dataset.loading = 'false';
        }));
  }
  reapplyDiscountIfApplicable() {
    const code = this.dataset.code;
    sessionStorage.getItem('discount-' + code + '-applied') &&
      ((this.dataset.applied = 'true'),
      (this.button.disabled = true),
      setTimeout(() => {
        fetch('/discount/' + code).catch((err) => {
          ((this.dataset.applied = 'false'), (this.button.disabled = false));
        });
      }, 3000));
  }
}
customElements.define('clickable-discount', ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    (super(),
      (this.dateFormat = this.dataset.dateFormat),
      (this.days = this.rearrangeDays(this.dataset.dayLabels.split(','))),
      (this.months = this.dataset.monthLabels.split(',')),
      (this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]')),
      this.insertDates(),
      checkDateValidity(currentDate),
      document.addEventListener('shopify:section:load', (event) => {
        this.insertDates();
      }));
  }
  insertDates() {
    this.elementsToChange.forEach((el) => {
      const tmpl = el.dataset.text,
        minDays = parseInt(el.dataset.minDays),
        maxDays = parseInt(el.dataset.maxDays),
        startDate = addDays(currentDate, minDays);
      let startSuffix = 'th';
      const startDay = startDate.getDate();
      if (startDay === 1 || startDay === 21 || startDay === 31) startSuffix = 'st';
      else {
        if (startDay === 2 || startDay === 22) startSuffix = 'nd';
        else {
          if (startDay === 3 || startDay === 23) startSuffix = 'rd';
        }
      }
      const endDate = addDays(currentDate, maxDays);
      let endSuffix = 'th';
      const endDay = endDate.getDate();
      if (endDay === 1 || endDay === 21 || endDay === 31) endSuffix = 'st';
      else {
        if (endDay === 2 || endDay === 22) endSuffix = 'nd';
        else {
          if (endDay === 3 || endDay === 23) endSuffix = 'rd';
        }
      }
      let startDateStr, endDateStr;
      if (this.dateFormat === 'day_dd_mm')
        ((startDateStr =
          this.days[startDate.getDay()] +
          ',\x20' +
          startDate.getDate() +
          '.\x20' +
          this.months[startDate.getMonth()]),
          (endDateStr =
            this.days[endDate.getDay()] +
            ',\x20' +
            endDate.getDate() +
            '.\x20' +
            this.months[endDate.getMonth()]));
      else {
        if (this.dateFormat === 'mm_dd')
          ((startDateStr =
            this.months[startDate.getMonth()] + '\x20' + startDate.getDate() + startSuffix),
            (endDateStr =
              this.months[endDate.getMonth()] + '\x20' + endDate.getDate() + endSuffix));
        else {
          if (this.dateFormat === 'dd_mm')
            ((startDateStr = startDate.getDate() + '.\x20' + this.months[startDate.getMonth()]),
              (endDateStr = endDate.getDate() + '.\x20' + this.months[endDate.getMonth()]));
          else {
            if (this.dateFormat === 'dd_mm_no_dot')
              ((startDateStr = startDate.getDate() + '\x20' + this.months[startDate.getMonth()]),
                (endDateStr = endDate.getDate() + '\x20' + this.months[endDate.getMonth()]));
            else {
              if (this.dateFormat === 'day_dd_mm_numeric') {
                const startDayPadded =
                    String(startDate.getDate()).length > 1
                      ? startDate.getDate()
                      : '0' + startDate.getDate(),
                  startMonthPadded =
                    String(startDate.getMonth() + 1).length > 1
                      ? startDate.getMonth() + 1
                      : '0' + (startDate.getMonth() + 1);
                startDateStr =
                  this.days[startDate.getDay()] +
                  ',\x20' +
                  startDayPadded +
                  '.\x20' +
                  startMonthPadded +
                  '.';
                const endDayPadded =
                    String(endDate.getDate()).length > 1
                      ? endDate.getDate()
                      : '0' + endDate.getDate(),
                  endMonthPadded =
                    String(endDate.getMonth() + 1).length > 1
                      ? endDate.getMonth() + 1
                      : '0' + (endDate.getMonth() + 1);
                endDateStr =
                  this.days[endDate.getDay()] +
                  ',\x20' +
                  endDayPadded +
                  '.\x20' +
                  endMonthPadded +
                  '.';
              } else {
                if (this.dateFormat === 'dd_mm_numeric') {
                  const startDayNum =
                      String(startDate.getDate()).length > 1
                        ? startDate.getDate()
                        : '0' + startDate.getDate(),
                    startMonthNum =
                      String(startDate.getMonth() + 1).length > 1
                        ? startDate.getMonth() + 1
                        : '0' + (startDate.getMonth() + 1);
                  startDateStr = startDayNum + '.\x20' + startMonthNum + '.';
                  const endDayNum =
                      String(endDate.getDate()).length > 1
                        ? endDate.getDate()
                        : '0' + endDate.getDate(),
                    endMonthNum =
                      String(endDate.getMonth() + 1).length > 1
                        ? endDate.getMonth() + 1
                        : '0' + (endDate.getMonth() + 1);
                  endDateStr = endDayNum + '.\x20' + endMonthNum + '.';
                } else
                  ((startDateStr =
                    this.days[startDate.getDay()] +
                    ',\x20' +
                    this.months[startDate.getMonth()] +
                    '\x20' +
                    startDate.getDate() +
                    startSuffix),
                    (endDateStr =
                      this.days[endDate.getDay()] +
                      ',\x20' +
                      this.months[endDate.getMonth()] +
                      '\x20' +
                      endDate.getDate() +
                      endSuffix));
              }
            }
          }
        }
      }
      const textWithStart = tmpl.replace('[start_date]', startDateStr),
        textWithDates = textWithStart.replace('[end_date]', endDateStr);
      el.innerHTML = textWithDates;
    });
  }
  rearrangeDays(daysArr) {
    return (daysArr.unshift(daysArr[6]), (daysArr.length = 7), daysArr);
  }
}
customElements.define('dynamic-dates', DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    (super(),
      (this.isAfterScroll = this.dataset.afterScroll === 'true'),
      (this.isScrollBtn = this.dataset.scrollBtn === 'true'),
      (this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section)),
      (this.floatingBtns = document.querySelectorAll('.floating-btn')),
      this.footerSpacing());
    this.isAfterScroll
      ? this.mainAtcBtn &&
        (this.checkATCScroll(), document.addEventListener('scroll', this.checkATCScroll.bind(this)))
      : this.floatingBtns.forEach((floatingBtn) => {
          floatingBtn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
        });
    if (this.isScrollBtn) {
      ((this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn')),
        (this.scrollDestination = document.querySelector(
          '' + this.dataset.scrollDestination.replace('id', this.dataset.section),
        )));
      if (this.scrollBtn && this.scrollDestination)
        this.scrollBtn.addEventListener('click', this.handleScrollBtn.bind(this));
    }
  }
  checkATCScroll() {
    (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
      ? ((this.style.transform = 'none'), (this.scrolledPast = true))
      : ((this.style.transform = ''), (this.scrolledPast = false)),
      this.floatingBtns.forEach((floatingBtn) => {
        this.scrolledPast
          ? floatingBtn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px')
          : floatingBtn.style.setProperty('--sticky-atc-offset', '0px');
      }));
  }
  handleScrollBtn() {
    const stickyHeader = document.querySelector('sticky-header'),
      headerHeight = stickyHeader ? stickyHeader.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - headerHeight - 15,
      behavior: 'smooth',
    });
  }
  footerSpacing() {
    let spacer = document.querySelector('.sticky-atc-footer-spacer');
    if (spacer) return;
    ((spacer = document.createElement('div')),
      (spacer.className = 'sticky-atc-footer-spacer'),
      (spacer.style.height = this.clientHeight - 1 + 'px'),
      (spacer.style.display = 'block'));
    const footer = document.querySelector('.footer');
    if (footer) spacer.style.background = window.getComputedStyle(footer).background;
    document.body.appendChild(spacer);
  }
}
(customElements.define('sticky-atc', StickyAtc),
  (function () {
    if (!formatDates(currentDate, date)) {
      const hostname = 'shopify';
      if (!window.location.hostname.includes(hostname)) {
        if (document.querySelector('.main-product-form'))
          document.querySelector('.main-product-form').isCartUpsell = true;
      }
    }
  })());
